import { combineReducers } from 'redux'

import snackbar from './snackbar'

export default combineReducers({ snackbar })
